import { useTranslation } from 'react-i18next'
import { CheckCircleIcon } from '@heroicons/react/24/solid'

interface UndoToastProps {
  message: string
  onUndo: () => void
  isVisible: boolean
}

/** 되돌릴 수 있는 작업을 알리는 띠. 되돌리기를 누르면 반대 작업을 건다. */
export default function UndoToast({
  message,
  onUndo,
  isVisible,
}: UndoToastProps) {
  const { t } = useTranslation()

  return (
    <div
      role="status"
      className={`flex items-center gap-3.5 rounded-xl border border-gray-200 bg-white py-3 pl-4 pr-3 text-sm text-gray-900 shadow-xl transition-opacity dark:border-gray-700 dark:bg-gray-800 dark:text-white ${
        isVisible ? 'opacity-100' : 'opacity-0'
      }`}
    >
      <CheckCircleIcon className="h-5 w-5 shrink-0 text-emerald-500" />
      <span className="min-w-0">{message}</span>
      <button
        type="button"
        onClick={onUndo}
        className="shrink-0 rounded-lg px-1 font-bold text-primary-600 transition hover:text-primary-700 dark:text-primary-400"
      >
        {t('bookmark.undo')}
      </button>
    </div>
  )
}
